import React from 'react';
import styled from 'styled-components';
import { Title, Body } from '@vds/typography';
import PropTypes from 'prop-types';

const WhiteSection = styled.div`
  background-color: white;
  height: auto;
  padding-bottom: 35px;
`;

const WhiteSectionInner = styled.div`
  color: black;
  height: auto;
  padding: 20px 10px 10px 0px;
  width: ${(props) => (props.width ? props.width : '50%')};
  @media (max-width: 769px) {
    width: ${(props) => (props.width ? props.width : '90%')};
  }
  p {
    color: black;
  }
  p {
    margin-top: 20px;
  }
`;

function DarkView(props) {
  return (
    <>
      <Body>
        <WhiteSection>
          <WhiteSectionInner width={props.width}>
            {props.header && (
              <Title color="#000000" primitive="h3">
                {props.header}
              </Title>
            )}
            {props.body && props.body}
          </WhiteSectionInner>
          {props.hotspotLink && props.hotspotLink}
        </WhiteSection>
      </Body>
    </>
  );
}

export default DarkView;

DarkView.propTypes = {
  width: PropTypes.string,
  header: PropTypes.string,
  body: PropTypes.string,
  hotspotLink: PropTypes.string,
};
